import withLocalWidgets from '../../with-local-widgets';

function WidgetsLoader() {
  return null;
}

export default withLocalWidgets(WidgetsLoader);
